import api from './api';
import { PagoReal, PaginatedResponse, GraficaPagosMensuales } from '../types';

class PaymentsService {
  async getPagos(page = 1, limit = 10, search?: string): Promise<PaginatedResponse<PagoReal>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) {
      params.append('search', search);
    }

    const response = await api.get<PaginatedResponse<PagoReal>>(`/pagos?${params}`);
    return response.data;
  }

  async getPagoById(id: number): Promise<PagoReal> {
    const response = await api.get<PagoReal>(`/pagos/${id}`);
    return response.data;
  }

  async createPago(pago: Omit<PagoReal, 'id' | 'createdAt' | 'updatedAt'>): Promise<PagoReal> {
    const response = await api.post<PagoReal>('/pagos', pago);
    return response.data;
  }

  async updatePago(id: number, pago: Partial<PagoReal>): Promise<PagoReal> {
    const response = await api.put<PagoReal>(`/pagos/${id}`, pago);
    return response.data;
  }

  async deletePago(id: number): Promise<void> {
    await api.delete(`/pagos/${id}`);
  }

  async efectuarPagoProgramado(pagoProgramadoId: number, data: {
    fechaPago: string;
    monto: number;
    montoBruto?: number;
    montoNeto?: number;
    detalleRetenciones?: string;
    metodoPago: string;
    referencia?: string;
    observaciones?: string;
  }): Promise<PagoReal> {
    const response = await api.post<PagoReal>(`/pagos/efectuar-programado/${pagoProgramadoId}`, data);
    return response.data;
  }

  async getFlujoCaja(fechaInicio: string, fechaFin: string): Promise<any> {
    const params = new URLSearchParams({
      fechaInicio,
      fechaFin,
    });
    
    const response = await api.get(`/pagos/flujo-caja?${params}`);
    return response.data;
  }

  async getResumenPagos(fechaInicio: string, fechaFin: string): Promise<any> {
    const params = new URLSearchParams({
      fechaInicio,
      fechaFin,
    });
    
    const response = await api.get(`/pagos/resumen?${params}`);
    return response.data;
  }

  // Pagos Reales
  async getPagosReales(page = 1, limit = 10, search?: string): Promise<PaginatedResponse<PagoReal>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) {
      params.append('search', search);
    }

    const response = await api.get<PaginatedResponse<PagoReal>>(`/pagos-reales?${params}`);
    return response.data;
  }

  async getPagoRealById(id: number): Promise<PagoReal> {
    const response = await api.get<PagoReal>(`/pagos-reales/${id}`);
    return response.data;
  }

  async createPagoReal(pago: {
    contratoId: number;
    fechaPago: string;
    monto: number;
    montoBruto?: number;
    montoNeto?: number;
    detalleRetenciones?: string;
    metodoPago: string;
    referencia?: string;
    observaciones?: string;
  }): Promise<PagoReal> {
    const response = await api.post<PagoReal>('/pagos-reales', pago);
    return response.data;
  }

  async updatePagoReal(id: number, pago: {
    contratoId?: number;
    fechaPago?: string;
    monto?: number;
    montoBruto?: number;
    montoNeto?: number;
    detalleRetenciones?: string;
    metodoPago?: string;
    referencia?: string;
    observaciones?: string;
  }): Promise<PagoReal> {
    const response = await api.put<PagoReal>(`/pagos-reales/${id}`, pago);
    return response.data;
  }

  async deletePagoReal(id: number): Promise<void> {
    await api.delete(`/pagos-reales/${id}`);
  }

  async getGraficaPagosMensuales(anio?: number): Promise<GraficaPagosMensuales> {
    const params = new URLSearchParams();
    
    if (anio) {
      params.append('anio', anio.toString());
    }

    const response = await api.get<GraficaPagosMensuales>(`/pagos/grafica/mensual?${params}`);
    return response.data;
  }

  async getTotalesPeriodo(fechaInicio: string, fechaFin: string): Promise<{
    fechaInicio: string;
    fechaFin: string;
    totalMonto: number;
    totalMontoNeto: number;
    totalRetencion: number;
    cantidadPagos: number;
  }> {
    const params = new URLSearchParams({
      fechaInicio,
      fechaFin,
    });
    
    const response = await api.get(`/pagos/totales?${params}`);
    return response.data;
  }
}

const paymentsService = new PaymentsService();
export default paymentsService;